import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { CustomerDto, CustomerNoteDto, CustomerNoteEditDto, newCustomerNote } from "./types";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propBoolField, propDateField, propEnumField, propTextField } from "../../common/entityStoreForm";
import { propLengthMax, propRequired } from "../../common/entityStoreValidators";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";
import { useCustomerNoteActionTypes, useCustomerNoteTypes } from "../../common/enum";
import { UserTypeId, useAccountStore } from "../../common/account";

const priorityEditorUserTypeIds = [UserTypeId.Admin, UserTypeId.Supervisor];

export const ContactDialog = (props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    serverData?: CustomerNoteDto;
}) => {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [{ useCustomerNoteStore }] = useState(() => {
        const initialData: CustomerNoteEditDto = !props.serverData ? newCustomerNote(customer.id!) :
            { ...props.serverData, customerId: customer.id! };
        const useCustomerNoteStore = createEntityStore<CustomerNoteEditDto>({
            data: initialData, path: "customers/customerNotes", id: initialData.id, fetchOnInit: false, getNewId: p => p.id!,
            saveProps: ["customerId", "txt", "customerNoteTypeId", "customerNoteActionTypeId", "isPriority"],
            onSaved() {
                props.useCustomerStore.getState().fetchServerData();
                props.close();
            },
            propValidators: [
                propRequired("customerNoteTypeId"),
                propRequired("customerNoteActionTypeId"),
                propRequired("txt"),
                propLengthMax("txt", 2550),
            ]
        });
        return { useCustomerNoteStore };
    });
    const { save, isSaveDisabled, id, userId } = useCustomerNoteStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled, id: p.entityId, userId: p.serverData.userId }));
    const accountStore = useAccountStore(p => ({ userId: p.data?.accessTokenDecoded.userId, userTypeId: p.data?.accessTokenDecoded.userTypeId }));
    const canManage = accountStore.userTypeId !== UserTypeId.View && accountStore.userTypeId !== UserTypeId.CollectionAgency &&
        (props.serverData == null || accountStore.userId === userId);
    return <>
        <DialogTitle style={{ cursor: "all-scroll" }}>{customerDialogTitle(id == null ? "New contact" : "Edit contact", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={4}>{propDateField(useCustomerNoteStore)("dte", null, "Date", { disabled: true })}</Grid>
                <Grid item xs={4}>{propEnumField(useCustomerNoteStore)("customerNoteTypeId", "Type", useCustomerNoteTypes, { disabled: !canManage })}</Grid>
                <Grid item xs={4}>{propEnumField(useCustomerNoteStore)("customerNoteActionTypeId", "Action", useCustomerNoteActionTypes, { disabled: !canManage })}</Grid>
                <Grid item xs={12}>{propTextField(useCustomerNoteStore)("txt", "Note", { multiline: true, disabled: !canManage })}</Grid>
                <Grid item xs={12}>{propBoolField(useCustomerNoteStore)("isPriority", "Always on top", {
                    disabled: !canManage || accountStore.userTypeId == null || !priorityEditorUserTypeIds.includes(accountStore.userTypeId),
                })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button disabled={isSaveDisabled || !canManage} onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};
